// import React from 'react';
// import { Link } from 'react-router-dom';
// import errorPage from '../assets/error-404.png'
// import './notfound.css'
// import {useState} from 'react'
// import Search from 'antd/es/transfer/search';

// const NotFound = () => {
//   const [count, setCount]=useState(0);
//   const [search,setSearch]=useState('')
//   const names = ['Alice', 'Bob', 'Charlie', 'David'];
//   const searchfilter=(e)=>{
//     setSearch(e.target.value)
//   }
//   const names2=names.filter((name)=>{return name.toLowerCase().includes(search)})
//   return (
//     <div className="not-found">
//         <div>

//         <img src={errorPage} alt='404'/>
//              <h2>Page Not Found</h2>
//       <button><Link to="/">Go to Home</Link></button>  
//       </div>
// <div>{count}{search}{names2.map((name, index) => {
//   return <p key={index}>{name}</p>;
// })};</div>

// <button onClick={()=>setCount(count+1)}>+</button>
// <button onClick={()=>setCount(count-1)}>-</button>
// <button onClick={()=>setCount(0)}>Reset</button>
// <input type='text' onChange={searchfilter}/>



//     </div>
//   );
// };

// export default NotFound;
import React, { useState } from 'react';



function NotFound() {
  const [formdata,setFormdata]=useState({name:''})
 
  return (
   <>
   <div>{formdata.name}</div>
   <input type="text" name='name' onChange={(e)=>{setFormdata({...formdata,[e.target.name]:e.target.value})} }/>
   </>
  );
}

export default NotFound; 